// In addition we need to pass in the number of pages.

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import SearchFilterMenu from './SearchFilterMenu';
import SearchResultContainer from './SearchResultContainer';
import { INITIAL_STATE } from './SearchFilterMenu/constants';

const filterParams = (res) => {
  const isArray = Array.isArray(res);
  if (isArray && res.length > 0) return JSON.stringify(res);
  if ((isArray && !(res.length > 0)) || !res) return '';
  return res;
};

const convertStateToParams = (params, currentPage) => {
  const paramsCopy = Object.entries(params).map((entry) => Object.entries(entry[1]));
  const convertedParams = paramsCopy.reduce((prev, curr) => {
    const dict = {
      ...prev,
    };
    for (let i = 0, ii = curr.length; i < ii; i += 1) {
      dict[curr[i][0]] = filterParams(curr[i][1]);
    }
    return dict;
  }, {});

  return {
    ...convertedParams,
    page: currentPage,
    format: 'json',
  };
};

const convertParamsToUrl = (params) => {
  const paramArray = Object.entries(params);
  let url = '/search?';
  for (let i = 0, ii = paramArray.length; i < ii; i += 1) {
    const withoutSpace = paramArray[i][0].replace(/ /g, '+');
    if (i === 0 && paramArray[i][0] !== 'format') {
      url += `${withoutSpace}=${paramArray[i][1]}`;
    } else if (paramArray[i][0] !== 'format') {
      url += `&${withoutSpace}=${paramArray[i][1]}`;
    }
  }
  return url;
};

class SearchContainer extends PureComponent {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  static async getConsultants(params, currentPage) {
    params.page = currentPage;
    const response = await axios.get(
      '/search',
      {
        params,
      },
    );
    return {
      consultants: response.data.consultants,
      totalResults: response.data.total_results,
      queryId: response.data.query,
      totalPages: response.data.total_pages,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      searchTriggered: false,
      consultants: props.consultants,
      queryId: props.query,
      totalResults: props.totalResults,
      currentPage: 1,
      totalPages: props.totalPages,
      params: INITIAL_STATE.selections,
    };

    this.setSelectionState = this.setSelectionState.bind(this);
    this.handleParamChange = this.handleParamChange.bind(this);
    this.handleConsultantFetch = this.handleConsultantFetch.bind(this);
    this.handleConsultantChange = this.handleConsultantChange.bind(this);
    this.setWindowUrlParams = this.setWindowUrlParams.bind(this);
    this.clearParams = this.clearParams.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { params, currentPage } = this.state;
    this.setState({ params: convertStateToParams(params, currentPage) });
  }

  async componentDidUpdate(_prevProps, prevState) {
    const { searchTriggered } = this.state;
    if (searchTriggered !== prevState.searchTriggered && searchTriggered) {
      await this.handleConsultantFetch();
    }
  }

  setCurrentPage(currentPage) {
    this.setState({
      currentPage,
    }, async () => {
      await this.handleConsultantFetch();
    });
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  setSelectionState(params) {
    const { currentPage } = this.state;
    this.setState({
      searchTriggered: true,
      params: convertStateToParams(params, currentPage),
    });
  }

  setWindowUrlParams() {
    const { params } = this.state;
    window.history.pushState({ path: window.location.pathname }, '', convertParamsToUrl(params));
  }

  clearParams() {
    this.setState({
      params: convertStateToParams(INITIAL_STATE.selections, 1),
      searchTriggered: true,
    }, () => {
      this.setWindowUrlParams();
    });
  }

  handleParamChange(newParams) {
    this.setState({
      params: newParams,
      searchTriggered: true,
    });
  }

  async handleConsultantFetch() {
    const { params, currentPage } = this.state;
    const resultsHash = await this.constructor.getConsultants(params, currentPage);
    const {
      consultants, totalResults, queryId, totalPages,
    } = resultsHash;
    this.handleConsultantChange(consultants, totalResults, queryId, totalPages);
  }

  handleConsultantChange(consultants, totalResults, queryId, totalPages) {
    this.setState({
      consultants,
      totalResults,
      queryId,
      totalPages,
      currentPage: 1,
      searchTriggered: false,
    }, () => this.setWindowUrlParams());
  }

  render() {
    const {
      searchTriggered,
      consultants,
      totalResults,
      queryId,
      currentPage,
      totalPages,
    } = this.state;
    const {
      location,
      csrfToken,
      workLocationOptions,
      durationOptions,
      timePerWeekOptions,
      inviteUrl,
      inviterEmailDomain,
      viewingAsEmployer,
    } = this.props;

    return (
      <Fragment>
        <div className="row">
          <div className="d-none d-md-block">
            <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <h1 className="hero-header">Search for consultants</h1>
            </div>
            <div className="tabs">
              <a
                className="tab-active body-text-2 toggle-all-talents-tab tab"
                role="button"
                href="/search"
              >
                <i className="fa fa-users" />
                All Talents
              </a>
              <a className="body-text-2 toggle-saved-tab tab" role="button" href="/search/saved">
                <i className="fa fa-heart" />
                Saved
              </a>
            </div>
          </div>
          <div className="d-block d-md-none">
            <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
              <div className="tabs">
                <SearchFilterMenu
                  {...this.props}
                  setSelectionState={this.setSelectionState}
                  clearParams={this.clearParams}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <div className="mobile-header mt-3">
                <h1 className="mobile-cta">Search consultants</h1>
                <button
                  className="btn search-filter-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                >
                  <i className="fa fa-filter me-2" />
                  Filter
                </button>
              </div>
              <hr className="mt-3" />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="d-none d-md-block">
            <div className="left-panel col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <SearchFilterMenu
                {...this.props}
                setSelectionState={this.setSelectionState}
                clearParams={this.clearParams}
              />
            </div>
          </div>

          <div className="d-block d-md-none">
            <div
              className="collapse left-panel col-lg-4 col-md-5 col-sm-12 col-xs-12"
              id="collapseFilters"
            >
              {totalResults > 0
                && (
                <div className="total-results body-text-2">
                  <span className="medium-weight">
                    {totalResults}
                    {' '}
                    consultants matching your criteria
                  </span>
                </div>
                )}
              <SearchResultContainer
                loading={searchTriggered}
                consultants={consultants}
                location={location}
                csrfToken={csrfToken}
                workLocationOptions={workLocationOptions}
                durationOptions={durationOptions}
                timePerWeekOptions={timePerWeekOptions}
                query={queryId}
                inviteUrl={inviteUrl}
                inviterEmailDomain={inviterEmailDomain}
                currentPage={currentPage}
                setCurrentPage={this.setCurrentPage}
                viewingAsEmployer={viewingAsEmployer}
                totalPages={totalPages}
              />
            </div>
          </div>
          <div className="right-panel col-lg-8 col-md-7 col-sm-12 col-xs-12">
            {totalResults > 0
              && (
              <div className="total-results body-text-2">
                <span className="medium-weight">
                  {totalResults}
                  {' '}
                  consultants matching your criteria
                </span>
              </div>
              )}
            <SearchResultContainer
              loading={searchTriggered}
              consultants={consultants}
              location={location}
              csrfToken={csrfToken}
              workLocationOptions={workLocationOptions}
              durationOptions={durationOptions}
              timePerWeekOptions={timePerWeekOptions}
              query={queryId}
              inviteUrl={inviteUrl}
              inviterEmailDomain={inviterEmailDomain}
              currentPage={currentPage}
              setCurrentPage={this.setCurrentPage}
              viewingAsEmployer={viewingAsEmployer}
              totalPages={totalPages}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
SearchContainer.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.array]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.array]).isRequired,
  query: PropTypes.number,
  inviteUrl: PropTypes.string.isRequired,
  inviterEmailDomain: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  viewingAsEmployer: PropTypes.bool,
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  totalResults: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

SearchContainer.defaultProps = {
  query: '',
  viewingAsEmployer: true,
};

export default SearchContainer;
